var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E82A53",
    d: "M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18M7.469 7.469a.747.747 0 0 1 1.06 0l1.468 1.468 1.469-1.468a.75.75 0 0 1 1.06 1.06l-1.47 1.468 1.469 1.469a.75.75 0 0 1-1.06 1.06l-1.468-1.47-1.469 1.469a.75.75 0 0 1-1.06-1.06l1.47-1.468-1.47-1.469a.747.747 0 0 1 0-1.06Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.b30163081aa4960a6fb5480beb2a824d.svg";